var _style, _g, _g2, _rect, _rect2, _path, _rect3, _rect4, _g3, _rect5, _g4, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _rect6, _g5, _g6, _g7, _g8, _g9, _path3, _path4, _rect7, _path5, _g0, _g1, _g10, _path6, _rect8, _path7, _g11, _rect9, _g12, _g13, _path8, _g14, _g15, _g16, _g17, _rect0, _g18, _path9, _rect1, _path0, _polyline, _rect10, _path1, _rect11, _path10, _path11, _rect12, _path12, _path13, _path14, _path15, _rect13, _path16, _rect14, _path17, _g19, _rect15, _path18, _rect16, _path19, _path20, _rect17, _g20, _g21, _path21, _polygon, _path22, _path23;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#FF0000;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:none;stroke:#FF2600;stroke-width:2;stroke-miterlimit:10;}\n\t.st6{fill:#FF2600;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 121.26,
    y: -126.78,
    className: "st0",
    width: 24,
    height: 24
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M143.97-119.83L143.97-119.83L143.97-119.83l-5.66-5.66c-0.39-0.39-1.02-0.39-1.41,0 c-0.39,0.39-0.39,1.02,0,1.41l0.71,0.71l-4.22,4.22c-2.58-1.09-5.61-0.77-7.92,0.96c-0.48,0.36-0.53,1.08-0.1,1.51l9.79,9.79 c0.43,0.43,1.15,0.39,1.51-0.1c1.73-2.31,2.05-5.34,0.96-7.92l4.22-4.22l0.71,0.71c0.39,0.39,1.02,0.39,1.41,0 C144.36-118.8,144.36-119.44,143.97-119.83z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "123.56,-106.49 122.26,-103.78 124.97,-105.07 130.26,-110.36 128.85,-111.78  "
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -220,
    y: -44,
    className: "st2",
    width: 24,
    height: 24
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -220,
    y: -44,
    className: "st0",
    width: 24,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-202-43h-12c-1.1,0-2,0.9-2,2v18c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2v-18C-200-42.1-200.9-43-202-43z  M-212.5-23c-0.83,0-1.5-0.67-1.5-1.5s0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5S-211.67-23-212.5-23z M-212.5-27.5 c-0.83,0-1.5-0.67-1.5-1.5s0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5S-211.67-27.5-212.5-27.5z M-212.5-32c-0.83,0-1.5-0.67-1.5-1.5 s0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5S-211.67-32-212.5-32z M-208-23c-0.83,0-1.5-0.67-1.5-1.5s0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5 S-207.17-23-208-23z M-208-27.5c-0.83,0-1.5-0.67-1.5-1.5s0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5S-207.17-27.5-208-27.5z M-208-32 c-0.83,0-1.5-0.67-1.5-1.5s0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5S-207.17-32-208-32z M-203.5-23c-0.83,0-1.5-0.67-1.5-1.5 s0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5S-202.67-23-203.5-23z M-203.5-27.5c-0.83,0-1.5-0.67-1.5-1.5s0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5 S-202.67-27.5-203.5-27.5z M-203.5-32c-0.83,0-1.5-0.67-1.5-1.5s0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5S-202.67-32-203.5-32z M-202-37 h-12v-4h12V-37z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -176,
    y: -44,
    className: "st4",
    width: 24,
    height: 24
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -264,
    y: -44,
    className: "st4",
    width: 24,
    height: 24
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-248.47-35.9l-2.64-5.36c-0.49-0.99-1.29-0.99-1.78,0l-2.64,5.36l-5.93,0.86c-1.09,0.16-1.34,0.92-0.55,1.69l4.29,4.18 l-1.01,5.91c-0.19,1.09,0.46,1.56,1.44,1.05l5.3-2.79l5.3,2.79c0.98,0.51,1.62,0.04,1.44-1.05l-1.01-5.91l4.29-4.18 c0.79-0.77,0.54-1.53-0.55-1.69L-248.47-35.9z"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -132,
    y: -44,
    className: "st4",
    width: 24,
    height: 24
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-120.13-43c-5.76,0-10.42,4.15-10.42,9.26c0,3.3,1.95,6.2,4.88,7.84l-1.38,4.14c-0.06,0.18-0.03,0.37,0.08,0.52 c0.11,0.15,0.28,0.24,0.47,0.24c0.99,0,16.79-3.48,16.79-12.74C-109.71-38.85-114.37-43-120.13-43z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-153.04-32.8c-0.04-0.49-0.42-0.91-0.92-0.93c-0.94-0.04-1.81-0.61-2.19-1.53c-0.38-0.92-0.17-1.94,0.47-2.63 c0.33-0.36,0.32-0.93-0.01-1.3c-0.34-0.39-0.7-0.75-1.08-1.09c-0.38-0.33-0.98-0.38-1.35-0.04c-0.69,0.63-1.7,0.84-2.62,0.46 s-1.48-1.25-1.53-2.18c-0.02-0.51-0.48-0.9-0.98-0.93c-0.51-0.04-1.02-0.03-1.54,0c-0.49,0.04-0.91,0.42-0.93,0.92 c-0.04,0.94-0.61,1.81-1.53,2.19c-0.92,0.38-1.94,0.17-2.63-0.47c-0.36-0.33-0.93-0.32-1.3,0.01c-0.39,0.34-0.75,0.7-1.09,1.08 c-0.33,0.38-0.38,0.98-0.04,1.35c0.63,0.69,0.84,1.7,0.46,2.62c-0.38,0.92-1.25,1.48-2.18,1.53c-0.51,0.02-0.9,0.48-0.93,0.98 c-0.04,0.51-0.03,1.02,0,1.54c0.04,0.49,0.42,0.91,0.92,0.93c0.94,0.04,1.81,0.61,2.19,1.53c0.38,0.92,0.17,1.94-0.47,2.63 c-0.33,0.36-0.32,0.93,0.01,1.3c0.34,0.39,0.7,0.75,1.08,1.09c0.38,0.33,0.98,0.38,1.35,0.04c0.69-0.63,1.7-0.84,2.62-0.46 c0.92,0.38,1.48,1.25,1.53,2.18c0.02,0.51,0.48,0.9,0.98,0.93c0.51,0.04,1.02,0.03,1.54,0c0.49-0.04,0.91-0.42,0.93-0.92 c0.04-0.94,0.61-1.81,1.53-2.19s1.94-0.17,2.63,0.47c0.36,0.33,0.93,0.32,1.3-0.01c0.39-0.34,0.75-0.7,1.09-1.08 c0.33-0.38,0.38-0.98,0.04-1.35c-0.63-0.69-0.84-1.7-0.46-2.62c0.38-0.92,1.25-1.48,2.18-1.53c0.51-0.02,0.9-0.48,0.93-0.98 C-153-31.77-153-32.28-153.04-32.8z M-164-28c-2.21,0-4-1.79-4-4c0-2.21,1.79-4,4-4s4,1.79,4,4C-160-29.79-161.79-28-164-28z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: -164,
    cy: -89,
    r: 11
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: -164,
    cy: -100,
    r: 2.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: -171.78,
    cy: -96.78,
    r: 2.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: -175,
    cy: -89,
    r: 2.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: -171.78,
    cy: -81.22,
    r: 2.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: -164,
    cy: -78,
    r: 2.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: -156.22,
    cy: -81.22,
    r: 2.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: -153,
    cy: -89,
    r: 2.5
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: -156.22,
    cy: -96.78,
    r: 2.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: -88,
    y: -44,
    className: "st4",
    width: 24,
    height: 24
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -44,
    y: -44,
    className: "st4",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24-40h-3v-1c0-1.1-0.9-2-2-2h-6c-1.1,0-2,0.9-2,2v1h-3c-0.55,0-1,0.45-1,1c0,0.55,0.45,1,1,1v15c0,1.1,0.9,2,2,2h12 c1.1,0,2-0.9,2-2v-15c0.55,0,1-0.45,1-1C-23-39.55-23.45-40-24-40z M-36-25c0,0.55-0.45,1-1,1s-1-0.45-1-1v-11c0-0.55,0.45-1,1-1 s1,0.45,1,1V-25z M-31-25c0,0.55-0.45,1-1,1s-1-0.45-1-1v-11c0-0.55,0.45-1,1-1s1,0.45,1,1V-25z M-29-40h-6v-1h6V-40z M-26-25 c0,0.55-0.45,1-1,1s-1-0.45-1-1v-11c0-0.55,0.45-1,1-1s1,0.45,1,1V-25z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: -44,
    className: "st4",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12-44c-3.77,0-6.96,0.89-8.67,1.48C2.53-42.24,2-41.48,2-40.63V-30c0,4,10,10,10,10s10-6,10-10v-10.63 c0-0.85-0.53-1.61-1.33-1.89C18.96-43.11,15.77-44,12-44z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: -40,
    className: "st0",
    width: 10,
    height: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M14.92-36.04L14.92-36.04l0-0.83c0-1.61-1.31-2.92-2.92-2.92s-2.92,1.31-2.92,2.92v0.83 c-0.46,0-0.83,0.37-0.83,0.83v4.17c0,0.46,0.37,0.83,0.83,0.83h5.83c0.46,0,0.83-0.37,0.83-0.83v-4.17 C15.75-35.67,15.38-36.04,14.92-36.04z M14.08-36.04H9.91v-0.83c0-1.15,0.93-2.08,2.08-2.08s2.08,0.93,2.08,2.08V-36.04z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: -95,
    className: "st0",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "95.04,-79.46 90.29,-74.71 89,-72 91.71,-73.29 96.46,-78.04  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103-94c-0.95,0.95-1.12,2.39-0.52,3.52l-4.22,4.22c-2.32-0.6-4.9,0-6.72,1.82l9.9,9.9 c1.82-1.82,2.42-4.39,1.82-6.72l4.22-4.22c1.13,0.6,2.57,0.44,3.52-0.52L103-94z M97.08-81.92l-1.92-1.92 c0.86-0.57,1.85-0.94,2.91-1.09l1.13,1.13C98.35-83.35,97.62-82.71,97.08-81.92z M101-84l-1-1l4-4l1,1L101-84z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: -44,
    className: "st4",
    width: 24,
    height: 24
  }))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.09-30v1c0,4.96,4.04,9,9,9s9-4.04,9-9v-1H47.09z M52.5-26c-0.83,0-1.5-0.67-1.5-1.5s0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5 S53.33-26,52.5-26z M59.5-26c-0.83,0-1.5-0.67-1.5-1.5s0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5S60.33-26,59.5-26z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.99-34.42c-0.12-3.11-1.52-5.53-3.69-6.73l0.59,6.73h-2.01l-0.68-7.82C59.08-43.24,58.23-44,57.21-44h-2.42 c-1.02,0-1.88,0.77-1.99,1.8l-0.68,7.78h-2.01l0.59-6.73c-2.17,1.2-3.58,3.62-3.69,6.73l-1.71,1.71L46-31h20l0.71-1.71L64.99-34.42z "
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: -44,
    className: "st4",
    width: 24,
    height: 24
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M144-44c-4.97,0-9,4.03-9,9c0.08,6.99,7.99,15,9,15s8.92-8,9-15C153-39.97,148.97-44,144-44z"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M144-31c-2.21,0-4-1.79-4-4s1.79-4,4-4s4,1.79,4,4S146.21-31,144-31z"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-252,44c-6.63,0-12,5.37-12,12s5.37,12,12,12c6.63,0,12-5.37,12-12S-245.37,44-252,44z M-247.22,59.36 c0.39,0.39,0.39,1.02,0,1.41c-0.2,0.2-0.45,0.29-0.71,0.29s-0.51-0.1-0.71-0.29l-3.36-3.36l-3.36,3.36 c-0.2,0.2-0.45,0.29-0.71,0.29s-0.51-0.1-0.71-0.29c-0.39-0.39-0.39-1.02,0-1.41l3.36-3.36l-3.36-3.36c-0.39-0.39-0.39-1.02,0-1.41 s1.02-0.39,1.41,0l3.36,3.36l3.36-3.36c0.39-0.39,1.02-0.39,1.41,0s0.39,1.02,0,1.41l-3.36,3.36L-247.22,59.36z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-208,44c-6.63,0-12,5.37-12,12s5.37,12,12,12c6.63,0,12-5.37,12-12S-201.37,44-208,44z M-203.24,57H-207v3.76 c0,0.55-0.45,1-1,1s-1-0.45-1-1V57h-3.76c-0.55,0-1-0.45-1-1s0.45-1,1-1h3.76v-3.76c0-0.55,0.45-1,1-1s1,0.45,1,1V55h3.76 c0.55,0,1,0.45,1,1S-202.69,57-203.24,57z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-152.58,55l-4.85-8.39c-0.36-0.62-1.02-1-1.73-1h-9.69c-0.71,0-1.37,0.38-1.73,1l-4.85,8.39c-0.36,0.62-0.36,1.38,0,2 l4.85,8.39c0.36,0.62,1.02,1,1.73,1h9.69c0.71,0,1.37-0.38,1.73-1l4.85-8.39C-152.22,56.38-152.22,55.62-152.58,55z M-164,50 c0.82,0,1.47,0.68,1.43,1.5l-0.38,5.5c-0.03,0.56-0.49,1-1.05,1c-0.56,0-1.02-0.44-1.05-1l-0.38-5.5C-165.47,50.68-164.82,50-164,50 z M-164,62c-0.83,0-1.5-0.67-1.5-1.5s0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5S-163.17,62-164,62z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: -132,
    y: 44,
    className: "st4",
    width: 24,
    height: 24
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M-110.9,48.25c-2.51-2.51-6.55-2.53-9.1-0.09c-2.54-2.45-6.59-2.42-9.1,0.09c-2.54,2.54-2.54,6.65,0,9.19l7.68,7.68 c0.78,0.78,2.05,0.78,2.83,0l7.68-7.68C-108.37,54.9-108.37,50.78-110.9,48.25z"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "96.1,-112.97 92.13,-108.99 90.83,-106.28 93.54,-107.57 97.52,-111.55  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M110.25-122.11l-3.59-3.59c-0.78-0.78-2.05-0.78-2.83,0l-4.16,4.16c-2.38-0.44-4.83,0.22-6.67,1.8l-1.13,1.13 l11.28,11.28l1.13-1.13c1.58-1.83,2.23-4.29,1.8-6.67l4.16-4.16C111.03-120.06,111.03-121.33,110.25-122.11z M97.75-116.46 l-1.92-1.92c0.86-0.57,1.85-0.94,2.91-1.09l1.13,1.13C99.02-117.89,98.29-117.24,97.75-116.46z M102.67-118.54l-1-1l3.5-3.5l1,1 L102.67-118.54z"
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 133.92,
    y: -120.34,
    transform: "matrix(0.7069 -0.7073 0.7073 0.7069 124.895 61.7115)",
    className: "st4",
    width: 5.97,
    height: 1
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -176,
    y: 88,
    className: "st4",
    width: 24,
    height: 24
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -176,
    y: 97,
    width: 2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: -154,
    y: 97,
    width: 2,
    height: 4
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M-155.87,90.64c-0.17-0.95-1-1.64-1.97-1.64h-12.33c-0.97,0-1.79,0.69-1.97,1.64L-174,101v7v2c0,0.55,0.45,1,1,1h3 c0.55,0,1-0.45,1-1v-2h10v2c0,0.55,0.45,1,1,1h3c0.55,0,1-0.45,1-1v-2v-7L-155.87,90.64z"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -132,
    y: 88,
    className: "st0",
    width: 24,
    height: 24
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -264,
    y: 88,
    className: "st0",
    width: 24,
    height: 24
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-255.12,98.05L-255.12,98.05l-2.71-0.9c-0.71-0.24-0.92-1.13-0.39-1.66l6.2-6.2c0.53-0.53,1.42-0.31,1.66,0.39l0.9,2.71 l0,0l5.07,5.07l0,0l2.71,0.9c0.71,0.24,0.92,1.13,0.39,1.66l-6.2,6.2c-0.53,0.53-1.42,0.31-1.66-0.39l-0.9-2.71l0,0L-255.12,98.05z "
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-254,100.58c-2.7,2.7-8.71,8.71-8.71,8.71c-0.39,0.39-0.39,1.02,0,1.41c0.39,0.39,1.02,0.39,1.41,0l8.71-8.71L-254,100.58 z"
  }))), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: -132,
    y: 88,
    className: "st4",
    width: 24,
    height: 24
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-109.29,94.95L-109.29,94.95L-109.29,94.95l-5.66-5.66c-0.39-0.39-1.02-0.39-1.41,0c-0.39,0.39-0.39,1.02,0,1.41 l0.71,0.71l-4.22,4.22c-2.58-1.09-5.61-0.77-7.92,0.96c-0.48,0.36-0.53,1.08-0.1,1.51l9.79,9.79c0.43,0.43,1.15,0.39,1.51-0.1 c1.73-2.31,2.05-5.34,0.96-7.92l4.22-4.22l0.71,0.71c0.39,0.39,1.02,0.39,1.41,0C-108.9,95.97-108.9,95.34-109.29,94.95z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-129.71,108.29 -131,111 -128.29,109.71 -123,104.41 -124.41,103  "
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M129.41-115.46l-1.92-1.92c0.86-0.57,1.85-0.94,2.91-1.09l1.13,1.13C130.68-116.89,129.96-116.24,129.41-115.46 z"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: -44,
    className: "st4",
    width: 24,
    height: 24
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M110-36.34L104.34-42c-0.39-0.39-1.02-0.39-1.41,0c-0.39,0.39-0.39,1.02,0,1.41l0.71,0.71l-3.89,3.89l-0.59-0.2 c-2.15-0.72-4.45-0.5-6.39,0.55c-0.57,0.31-0.66,1.11-0.2,1.57l9.48,9.48c0.46,0.46,1.25,0.38,1.57-0.19 c1.06-1.93,1.28-4.24,0.56-6.39l-0.2-0.59l3.89-3.89l0.71,0.71c0.39,0.39,1.02,0.39,1.41,0C110.39-35.32,110.39-35.95,110-36.34z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "95.9,-29.32 90.29,-23.71 89,-21 91.71,-22.29 97.32,-27.9 "
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 100.35,
    y: -37.02,
    transform: "matrix(0.7069 -0.7073 0.7073 0.7069 56.0493 62.2232)",
    className: "st4",
    width: 5.51,
    height: 1
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M97.82-31.64l-1.92-1.92c0.86-0.57,1.85-0.94,2.91-1.09l1.13,1.13C99.1-33.07,98.37-32.42,97.82-31.64z"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: -220,
    y: 0,
    className: "st0",
    width: 24,
    height: 24
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M-208,4c-7.08,0-11,6.08-11,8s3.92,8,11,8c7.08,0,11-6.08,11-8S-200.92,4-208,4z M-208,17c-2.76,0-5-2.24-5-5s2.24-5,5-5 c2.76,0,5,2.24,5,5S-205.24,17-208,17z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M-208,9c-0.28,0-0.54,0.05-0.79,0.12c0.18,0.25,0.29,0.55,0.29,0.88c0,0.83-0.67,1.5-1.5,1.5c-0.33,0-0.63-0.11-0.88-0.29 c-0.07,0.25-0.12,0.52-0.12,0.79c0,1.66,1.34,3,3,3c1.66,0,3-1.34,3-3S-206.34,9-208,9z"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: -176,
    y: 0,
    className: "st4",
    width: 24,
    height: 24
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M-159.07,11.31c0.03,0.23,0.07,0.45,0.07,0.69c0,2.76-2.24,5-5,5c-0.24,0-0.46-0.04-0.69-0.07l-2.59,2.59 c1.01,0.29,2.1,0.48,3.28,0.48c7.08,0,11-6.08,11-8c0-0.89-0.85-2.66-2.44-4.31L-159.07,11.31z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M-161.88,14.12C-161.88,14.12-161.88,14.12-161.88,14.12L-161.88,14.12z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M-153.29,1.29c-0.39-0.39-1.02-0.39-1.41,0l-3.99,3.99C-160.19,4.51-161.96,4-164,4c-7.08,0-11,6.08-11,8 c0,1.13,1.39,3.7,3.96,5.62l-3.67,3.67c-0.39,0.39-0.39,1.02,0,1.41c0.39,0.39,1.02,0.39,1.41,0l20-20 C-152.9,2.32-152.9,1.68-153.29,1.29z M-162.71,9.3C-163.1,9.11-163.54,9-164,9c-0.28,0-0.54,0.05-0.79,0.12 c0.18,0.25,0.29,0.55,0.29,0.88c0,0.83-0.67,1.5-1.5,1.5c-0.33,0-0.63-0.11-0.88-0.29c-0.07,0.25-0.12,0.52-0.12,0.79 c0,0.46,0.11,0.9,0.3,1.29l-1.46,1.46c-0.52-0.79-0.84-1.73-0.84-2.75c0-2.76,2.24-5,5-5c1.02,0,1.96,0.31,2.75,0.84L-162.71,9.3z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M-69-33h-1v-4c0-3.31-2.69-6-6-6s-6,2.69-6,6v4h-1c-1.1,0-2,0.9-2,2v8c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-8 C-67-32.1-67.9-33-69-33z M-72-33h-8v-4c0-2.21,1.79-4,4-4s4,1.79,4,4V-33z"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: -132,
    className: "st4",
    width: 24,
    height: 24
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M-109.85,16.31l-3.16-1.83c-0.48-0.27-1.09-0.11-1.37,0.37l-0.79,1.36c-0.25,0.43-0.79,0.63-1.25,0.43 c-3.66-1.61-6.6-4.54-8.22-8.2c-0.2-0.46-0.01-1,0.43-1.25l1.37-0.79c0.48-0.28,0.64-0.89,0.37-1.37l-1.83-3.16 c-0.28-0.48-0.89-0.64-1.37-0.37l-3.08,1.78c-0.74,0.43-1.11,1.27-0.97,2.11c1.42,8.34,8.01,14.92,16.35,16.33 c0.83,0.14,1.67-0.23,2.09-0.97l1.6-2.76C-109.21,17.2-109.37,16.59-109.85,16.31z"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: -88,
    y: 0,
    className: "st6",
    width: 24,
    height: 24
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-65,12c0-6.08-4.92-11-11-11s-11,4.92-11,11s4.92,11,11,11S-65,18.08-65,12z M-80,12c0-2.21,1.79-4,4-4 s4,1.79,4,4s-1.79,4-4,4S-80,14.21-80,12z"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-71.76,16.24c-0.5,0.5-1.06,0.88-1.66,1.17l2.2,2.2c0.56-0.35,1.09-0.76,1.58-1.25s0.9-1.02,1.25-1.58 l-2.2-2.2C-70.88,15.18-71.26,15.75-71.76,16.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-73.42,6.59c0.6,0.29,1.17,0.67,1.66,1.17s0.88,1.06,1.17,1.66l2.2-2.2c-0.35-0.56-0.76-1.09-1.25-1.58 s-1.02-0.9-1.58-1.25L-73.42,6.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-80.79,4.39c-0.56,0.35-1.09,0.76-1.58,1.25s-0.9,1.02-1.25,1.58l2.2,2.2c0.29-0.6,0.67-1.17,1.17-1.66 c0.5-0.5,1.06-0.88,1.66-1.17L-80.79,4.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-78.58,17.41c-0.6-0.29-1.17-0.67-1.66-1.17c-0.5-0.5-0.88-1.06-1.17-1.66l-2.2,2.2 c0.35,0.56,0.76,1.09,1.25,1.58s1.02,0.9,1.58,1.25L-78.58,17.41z"
  }))), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: -264,
    y: 0,
    className: "st4",
    width: 24,
    height: 24
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M-244,0h-12l-5.1,14h4l-3.64,10h4l14.42-16h-4.6L-244,0L-244,0z"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: -44,
    y: 0,
    className: "st4",
    width: 24,
    height: 24
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M-21,8V6c0-1.1-0.9-2-2-2h-18c-1.1,0-2,0.9-2,2v2H-21z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M-43,12v6c0,1.1,0.9,2,2,2h18c1.1,0,2-0.9,2-2v-6H-43z M-33,16h-6c-0.55,0-1-0.45-1-1s0.45-1,1-1h6c0.55,0,1,0.45,1,1 S-32.45,16-33,16z"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 24,
    height: 24
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M22,3H2C0.9,3,0,3.9,0,5v14c0,1.1,0.9,2,2,2h20c1.1,0,2-0.9,2-2V5C24,3.9,23.1,3,22,3z M2,19V5h20v9l-4.3-3.44 c-0.4-0.32-0.97-0.29-1.33,0.07l-4.66,4.66c-0.39,0.39-1.02,0.39-1.41,0l-1.59-1.59c-0.39-0.39-1.02-0.39-1.41,0L2,19L2,19L2,19 L2,19z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 6.5,
    cy: 9,
    r: 2
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -88,
    y: 44,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 -152 112)",
    className: "st4",
    width: 24,
    height: 24
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-64.59,45.85c0.25-0.77-0.48-1.5-1.26-1.26l-21.32,6.81c-0.38,0.16-0.62,0.44-0.66,0.77 c-0.03,0.33,0.15,0.66,0.49,0.89l7.1,5.21l8.21-6.24l-6.24,8.21l5.2,7.1c0.21,0.32,0.5,0.5,0.81,0.5c0.36,0,0.68-0.25,0.85-0.66 L-64.59,45.85z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "-169.69,94 -170.79,100 -157.21,100 -158.31,94 "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-168,102h-2c-0.55,0-1,0.45-1,1c0,0.55,0.45,1,1,1h2c0.55,0,1-0.45,1-1C-167,102.45-167.45,102-168,102z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-158,102h-2c-0.55,0-1,0.45-1,1c0,0.55,0.45,1,1,1h2c0.55,0,1-0.45,1-1C-157,102.45-157.45,102-158,102z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgUpload);
export default __webpack_public_path__ + "static/media/img-upload.f10e4c52bd6badd1e57b9dacbef75615.svg";
export { ForwardRef as ReactComponent };